import { isPlainObject, omit } from 'es-toolkit'
import type { z } from 'zod'

// protect-types still types a report with one `assetVrn`, where analyze-v2 sends `assetVrns`.
export type WithAssetVrns<T> = T extends unknown ? Omit<T, 'assetVrn'> & { assetVrns: string[] } : never

// A response is either the protect-types shape or the analyze-v2 shape.
export type AssetShape<T> = T | WithAssetVrns<T>

// Analyze v1 reports name one `assetVrn`, analyze-v2 reports name `assetVrns` and may also send the first as `assetVrn`. The UI reads `assetVrns`.
export const toAssetVrns = (value: unknown) => {
	if (!isPlainObject(value) || !('assetVrn' in value) || 'assetVrns' in value) return value
	return { ...omit(value, ['assetVrn']), assetVrns: [value.assetVrn] }
}

// An analyze-v2 from before `assetVrns` needs `assetVrn`, so one asset is sent as both; remove that when it is everywhere.
export const toAnalyzeV2Request = <T extends { assetVrns: readonly string[] }>(schema: z.ZodType<T>, request: unknown) => {
	const parsed = schema.parse(request)
	return parsed.assetVrns.length === 1 ? { ...parsed, assetVrn: parsed.assetVrns[0] } : parsed
}
